import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  max-height: 100%;
  gap: 4px;
`;

export const ContentWrapper = styled.div<{ $isFormOpen: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
  height: 100%;

  & > :first-child {
    margin-bottom: 0 !important;
  }

  ${({ $isFormOpen }) =>
    $isFormOpen &&
    css`
      max-width: 400px;
    `}
`;
